import request from '@/api/request'
 
 /**
  * dw扫码订单
  * 订单明细
  * @time 2022年3月7日 周一 下午10点56分
  * */
 export const getDwScancodeOrderTail = params =>
 request({
   url: '/snhZdwScancodeOrder/getScancodeOrder',
   method: 'get',
   params
 })
 
 /**
  * 百度智能云
  * 人脸识别
  * 人脸库管理API
  * 人脸更新
  * @time 2021年11月12日 周五 上午10点29分
  * */
 export const baiduFaceUpdate = data =>
 request({
   url: '/baiduFace/faceUpdate',
   method: 'post',
   data
 })
 
 /**
  * 百度智能云
  * 人脸识别
  * 人脸库管理API
  * 复制用户
  * @time 2021年11月12日 周五 上午9点48分
  * */
 export const baiduCopyUser = data =>
 request({
   url: '/baiduFace/copyUser',
   method: 'post',
   data
 })
 
 /**
  * 百度智能云
  * 人脸识别
  * 人脸库管理API
  * 删除用户
  * @time 2021年11月11日 周四 上午19点48分
  * */
 export const baiduDeleteUsers = data =>
 request({
   url: '/baiduFace/deleteUsers',
   method: 'post',
   data
 })
 
 /**
  * 百度智能云
  * 人脸识别
  * 人脸库管理API
  * 人脸删除
  * @time 2021年11月11日 周四 上午19点48分
  * */
 export const baiduFaceDel = data =>
 request({
   url: '/baiduFace/faceDel',
   method: 'post',
   data
 })
 
 /**
  * 百度智能云
  * 人脸识别
  * 人脸库管理API
  * 人脸注册
  * @time 2021年11月11日 周四 上午19点00分
  * */
 export const baiduFaceRegistration = data =>
 request({
   url: '/baiduFace/faceRegistration',
   method: 'post',
   data
 })
 
 /**
  * 百度智能云
  * 人脸识别
  * 人脸库管理API
  * 用户信息查询
  * @time 2021年11月11日 周四 上午18点16分
  * */
 export const baiduUserInformationQuery = data =>
 request({
   url: '/baiduFace/userInformationQuery',
   method: 'post',
   data
 })
 
 /**
  * 百度智能云
  * 人脸识别
  * 人脸库管理API
  * 获取用户人脸列表
  * @time 2021年11月11日 周四 上午17点28分
  * */
 export const baiduFaceGetAListOfUserFaces = data =>
 request({
   url: '/baiduFace/getAListOfUserFaces',
   method: 'post',
   data
 })
 
 /**
  * 百度智能云
  * 人脸识别
  * 人脸库管理API
  * 获取用户列表
  * @time 2021年11月11日 周四 上午9点25分
  * */
 export const baiduFaceGetUserList = data =>
 request({
   url: '/baiduFace/getUserList',
   method: 'post',
   data
 })
 
 /**
  * 百度智能云
  * 人脸识别
  * 人脸库管理API
  * 删除用户组
  * @time 2021年11月11日 周四 上午9点25分
  * */
 export const baiduFaceDeleteUserGroup = data =>
 request({
   url: '/baiduFace/deleteUserGroup',
   method: 'post',
   data
 })
 
 /**
  * 百度智能云
  * 人脸识别
  * 人脸库管理API
  * 创建用户组
  * @time 2021年11月11日 周四 上午9点23分
  * */
 export const baiduFaceCreateUserGroup = data =>
 request({
   url: '/baiduFace/createUserGroup',
   method: 'post',
   data
 })
 
 /**
  * 百度智能云
  * 人脸识别
  * 人脸库管理API
  * 组列表查询
  * @time 2021年10月22日 周五 上午15点46分
  * */
  export const getBaiduFaceGetGroupListQuery = params =>
  request({
    url: '/baiduFace/getGroupListQuery',
    method: 'get',
    params
  })
  
 /**
  * 综合商户管理
  * 微信支付宝对账单下载
  * @time 2021年10月22日 周五 上午15点46分
  * */
  export const ydGetSnhTransactionAliwxstatementPage = params =>
  request({
    url: '/snhTransactionAliwxstatement/getSnhTransactionAliwxstatementPage',
    method: 'get',
    params
  })
  
 /**
  * 综合商户管理
  * 内转出金对账单
  * @time 2021年10月22日 周五 上午11点53分
  * */
  export const ydGetSnhTransactionPlatmerchantstatePage = params =>
  request({
    url: '/snhTransactionPlatmerchantstate/getSnhTransactionPlatmerchantstatePage',
    method: 'get',
    params
  })
  
 /**
  * 综合商户管理
  * 内转出金对账单
  * @time 2021年10月12日 周四 下午14点39分
  * */
  export const ydGetSnhTransactionInwardtransferoutPage = params =>
  request({
    url: '/snhTransactionInwardtransferout/getSnhTransactionInwardtransferoutPage',
    method: 'get',
    params
  })
  
/**
 * 白名单用户列表
 * 绑定商户
 * 删除绑定
 * @time 2021年9月29日 周三 下午15点24分
 * */
 export const ydBindSnhWhitelistAndMerchantsDelBind = data =>
 request({
   url: '/snhWhitelistAndMerchants/delBind',
   method: 'post',
   data
 })
 
/**
 * 白名单与商户
 * 已绑定列表
 * @time 2021年9月29日 周三 下午14点39分
 * */
 export const ydGetWhitelistAndMerchantsPage = params =>
 request({
   url: '/snhWhitelistAndMerchants/getWhitelistAndMerchantsPage',
   method: 'get',
   params
 })
 
/**
 * 白名单用户列表
 * 绑定商户
 * @time 2021年9月29日 周三 下午14点39分
 * */
 export const ydBindSnhWhitelistAndMerchants = data =>
 request({
   url: '/snhWhitelistAndMerchants/save',
   method: 'post',
   data
 })
 
/**
 * 白名单
 * 选择商户
 * @time 2021年9月29日 周三 下午12点21分
 * */
 export const ydGetSnhMerchantWhitelistPage = params =>
 request({
   url: '/snh/merchant/getSnhMerchantPage',
   method: 'get',
   params
 })
 
 /**
  * 白名单
  * 新增或修改
  * @time 2021年12月7日 周二 上午10点48分
  * */
  export const ydSnhMerchantWhiteListSaveOrUpdate = data =>
  request({
    url: '/snhMerchantWhiteList/saveOrUpdate',
    method: 'post',
    data
  })
  
/**
 * 白名单
 * @time 2021年9月28日 周二 下午14点56分
 * */
 export const ydGetMerchantWhiteListPage = params =>
 request({
   url: '/snhMerchantWhiteList/getMerchantWhiteListPage',
   method: 'get',
   params
 })

/**
 * 菜单权限
 * @time 2021年8月13日 周五 上午11点29分
 * */
 export const ydGetMenuPermissions = data =>
 request({
   url: '/user/menuPermissions',
   method: 'post',
   data
 })
 
/**
 * 活动查看
 * @time 2021年8月2日 周二 下午14点14分
 * */
 export const ydGetActivityView = data =>
 request({
   url: '/snhFullReduction/getActivityView',
   method: 'post',
   data
 })
 
/**
 * 商户支持支付方式
 * 修改保存
 * @time 2021年7月27日 周二 下午14点57分
 * */
 export const ydMerchantSupportsPaymentMethod = data =>
 request({
   url: '/yd/snh/merchantSupportsPaymentMethod',
   method: 'post',
   data
 })
 
/**
 * 商户绑定意瑞云音响
 * @time 2021年6月25日 周五 上午10点08分
 * */
 export const ydSnhMerchantCloudSoundSaveOrUpdate = data =>
 request({
   url: '/snhMerchantCloudSound/saveOrUpdate',
   method: 'post',
   data
 })
 
/**
 * 商户绑定意瑞云音响
 * 分页查看
 * @time 2021年6月25日 周五 上午9点20分
 * */
 export const getSnhMerchantCloudSoundPage = params =>
 request({
   url: '/snhMerchantCloudSound/getSnhMerchantCloudSoundPage',
   method: 'get',
   params
 })
 
/**
 * 商户订单汇总
 * 分页查看
 * @time 2021年6月21日 周一 上午10点44分
 * */
 export const getMerchantOrderSummaryPage = params =>
 request({
   url: '/yd/snh/getMerchantOrderSummaryPage',
   method: 'get',
   params
 })
 
/**
 * 银达用户APP推送
 * @time 2021年6月18日 周四 下午11点28分
 * */
 export const ydUserPush = data =>
 request({
   url: '/ydUser/ydUserPush',
   method: 'post',
   data
 })
 
/**
 * 银达用户绑定商户
 * @time 2021年6月18日 周四 下午11点08分
 * */
 export const ydUserBindingMerchant = data =>
 request({
   url: '/ydUser/ydUserBindingMerchant',
   method: 'post',
   data
 })
 
/**
 * 试运行
 * 担保出金All
 * @time 2021年6月17日 周四 下午5点40分
 * */
 export const ydTestGuaranteePayment = data =>
 request({
   url: '/yd/snh/testGuaranteePayment',
   method: 'post',
   data
 })
 
 /**
  * 试运行
  * 担保出金 one
  * @time 2022年1月25日 周二 下午5点21分
  * */
  export const ydGuaranteedWithdrawalOne = data =>
  request({
    url: '/yd/snh/guaranteedWithdrawalOne',
    method: 'post',
    data
  })
 
/**
 * 营销补贴资金回退
 * @time 2021年6月15日 周二 上午10点18分
 * */
 export const ydSubsidyRefundMethod = data =>
 request({
   url: '/yd/snh/subsidyRefundMethod',
   method: 'post',
   data
 })
 
/**
 * 营销补贴资金查询
 * @time 2021年6月15日 周二 上午09点24分
 * */
 export const ydGetMarketingSubsidyFundInquiry = data =>
 request({
   url: '/yd/snh/getMarketingSubsidyFundInquiry',
   method: 'post',
   data
 })
 
/**
 * 营销补贴记录
 * 分页查看
 * @time 2021年6月12日 周二 上午15点00分
 * */
 export const ydGetSnhMarketingSubsidyRecordPage = params =>
 request({
   url: '/snhMarketingSubsidyRecord/getSnhMarketingSubsidyRecordPage',
   method: 'get',
   params
 })
 
/**
 * 商户与活动关系
 * 建立
 * 查看
 * 二级商户列表
 * @time 2021年6月8日 周二 上午10点38分
 * */
 export const ydBusinessListings = data =>
 request({
   url: '/snhMerchantsAndActivities/businessListings',
   method: 'post',
   data
 })
 
 /**
  * 商户与活动关系
  * 新增与更新
  * @time 2021年6月8日 周二 上午10点38分
  * */
  export const ydSaveOrUpdate = data =>
  request({
    url: '/snhMerchantsAndActivities/saveOrUpdate',
    method: 'post',
    data
  })
 
/**
 * 活动 新增或更新
 * @time 2021年5月29日 周六 下午16点24分
 * */
 export const snhFullReductionSaveOrUpdate = data =>
 request({
   url: '/snhFullReduction/saveOrUpdate',
   method: 'post',
   data
 })
 
/**
 * 二级商户入金交易
 * @time 2021年5月28日 周四 下午14点16分
 * */
 export const getSnhMerchantIngoldTransactionPage = params =>
 request({
   url: '/snhMerchantIngoldTransaction/getSnhMerchantIngoldTransactionPage',
   method: 'get',
   params
 })
 
/**
 * 二级商户出金交易
 * @time 2021年5月28日 周四 下午12点12分
 * */
 export const getSnhMerchantCashTransactionPage = params =>
 request({
   url: '/snhMerchantCashTransaction/getSnhMerchantCashTransactionPage',
   method: 'get',
   params
 })
 
/**
 * 二级商户账簿明细查询
 * @time 2021年5月18日 周四 下午11点23分
 * */
 export const getCheckSubMerAccDetailRequest = data =>
 request({
   url: '/yd/snh/getCheckSubMerAccDetailRequest',
   method: 'post',
   data
 })

/**
 * 查看用户 拥有角色
 * @time 2021年5月13日 周四 下午13点31分
 * */
 export const getUserRoleList = params =>
 request({
   url: '/user/getUserRoleList',
   method: 'get',
   params
 })
 
/**
 * 银达
 * 6.43	刷卡支付订单撤销请求
 * @author 黄开亮
 * @date 2021年5月11日 8点51分
 */
export const getCreditCardPaymentOrderCancellationRequest = data =>
request({
  url: '/yd/snh/creditCardPaymentOrderCancellationRequest',
  method: 'post',
  data
})

/**
 * 统一协议支付签约申请
 * @auth 黄开亮
 * @date 2021年4月26日 周一 下午19点49分
 * */
export const ydUnifiedSignApply = data =>
    request({
        url: '/yd/snh/unifiedSignApply',
        method: 'post',
        data
})

/**
 * 二级商户证照资料上传
 * @auth 黄开亮
 * @date 2021年4月26日 周一 下午19点49分
 * */
export const ydUploadSubMerCertRequest = data =>
    request({
        url: '/yd/snh/uploadSubMerCertRequest',
        method: 'post',
        data
})

/**
 * 保存管理菜单权限，新增或修改
 * */
export const ucUserManageAuto = data =>
    request({
        url: '/uc/user/manageAuto',
        method: 'post',
        data
})

/**
 * 满减活动 分页
 * @time 2021年4月21日 周三 上午9点41分
 * */
 export const getSnhFullReduction = params =>
 request({
   url: '/snhFullReduction/getSnhFullReduction',
   method: 'get',
   params
 })
 
/**
 * 订单 分页
 * @time 2021年4月21日 周三 上午9点41分
 * */
 export const getSnhOrderPage = params =>
 request({
   url: '/snhOrder/getSnhOrderPage',
   method: 'get',
   params
 })
 
/** 虹软AI begin **/
/**
 * 虹软AI
 * 人脸比对 1 -> N
 * @time 2021年4月5日 周一 下午5点08分
 * */
export const hrFaceComparison = data =>
request({
  url: '/hrFaceDatabase/faceComparison',
  method: 'post',
  data
})
/**
 * 虹软AI
 * 更新或修改
 * @time 2021年4月5日 周一 下午5点08分
 * */
export const hrFaceDatabaseSaveOrUpdate = data =>
request({
  url: '/hrFaceDatabase/saveOrUpdate',
  method: 'post',
  data
})
/**
 * 虹软AI
 * 分页
 * @time 2021年4月5日 周一 下午5点08分
 * */
 export const getHrFaceDatabasePageList = params =>
 request({
   url: '/hrFaceDatabase/getHrFaceDatabasePageList',
   method: 'get',
   params
 })
 
/** 虹软AI end **/


/** 市农行begin **/

/**
 * 商户收款码
 * @author 黄开亮
 * @date 2021年4月13日 15点00分
 */	
export const ydGetCollectionCode = data =>
request({
  url: '/yd/snh/getCollectionCode',
  method: 'post',
  data
})

/**
 * 未使用
 * 扫码支付
 * @author 黄开亮
 * @date 2021年4月10日 7点51分
 */	
export const ydPaymentByScanningCode = data =>
request({
  url: '/yd/snh/paymentByScanningCode',
  method: 'post',
  data
})

/**
 * 未使用
 * 6.30	微信支付请求
 * @author 黄开亮
 * @date 2021年4月10日 7点51分
 */	
export const ydWechatPaymentRequest = data =>
request({
  url: '/yd/snh/wechatPaymentRequest',
  method: 'post',
  data
})

/**
 * 未使用
 * 6.31	支付宝支付请求
 * @author 黄开亮
 * @date 2021年4月10日 7点51分
 */	
export const ydAlipayPaymentRequest = data =>
request({
  url: '/yd/snh/alipayPaymentRequest',
  method: 'post',
  data
})

/**
 * 6.7	批量退款
 * @author 黄开亮
 * @date 2021年4月10日 7点51分
 */	
export const ydBatchRefund = data =>
request({
  url: '/yd/snh/batchRefund',
  method: 'post',
  data
})

/**
 * 6.8	批量退款查询
 * @author 黄开亮
 * @date 2021年4月10日 7点51分
 */	
export const ydBatchRefundQuery = data =>
request({
  url: '/yd/snh/batchRefundQuery',
  method: 'post',
  data
})

/**
 * 6.9	单笔交易查询
 * @author 黄开亮
 * @date 2021年4月10日 7点51分
 */	
export const ydSingleTransactionQuery = data =>
request({
  url: '/yd/snh/singleTransactionQuery',
  method: 'post',
  data
})

/**
 * 6.21	单笔授权扣款
 * @author 黄开亮
 * @date 2021年4月10日 7点44分
 */	
export const ydSingleAuthorizedDeduction = data =>
request({
  url: '/yd/snh/singleAuthorizedDeduction',
  method: 'post',
  data
})

/**
 * 6.43	刷卡支付订单撤销请求
 * @author 黄开亮
 * @date 2021年4月10日 7点44分
 */	
export const ydCreditCardPaymentOrderCancellationRequest = data =>
request({
  url: '/yd/snh/creditCardPaymentOrderCancellationRequest',
  method: 'post',
  data
})

/**
 * 6.47	支出类账簿入金交易请求(活动金额)
 * @author 黄开亮
 * @date 2021年4月10日 7点44分
 */	
export const ydPaymentTransactionRequestOfExpenseAccountBook = data =>
request({
  url: '/yd/snh/paymentTransactionRequestOfExpenseAccountBook',
  method: 'post',
  data
})

/**
 * 6.47	支出类账簿入金交易请求(垫资金额)
 * @author 黄开亮
 * @date 2022年2月16日 16点32分
 */	
export const ydpaymentTransactionRequestOfExpenseAccountBookAdvanceFunds = data =>
request({
  url: '/yd/snh/paymentTransactionRequestOfExpenseAccountBookAdvanceFunds',
  method: 'post',
  data
})

/**
 *  7.3	担保确认请求
 * @author 黄开亮
 * @date 2021年4月10日 7点44分
 */	
export const ydGuaranteeConfirmationRequest = data =>
request({
  url: '/yd/snh/guaranteeConfirmationRequest',
  method: 'post',
  data
})

/**
 *  7.4	担保确认查询请求
 * @author 黄开亮
 * @date 2021年4月10日 7点44分
 */	
export const ydGuaranteeConfirmationInquiryRequest = data =>
request({
  url: '/yd/snh/guaranteeConfirmationInquiryRequest',
  method: 'post',
  data
})

/**
 * 6.37	内转出金对账单下载
 * @author 黄开亮
 * @date 2021年4月9日 22点38分
 */	
export const ydDownloadInternalTransferOutStatement = data =>
request({
  url: '/yd/snh/downloadInternalTransferOutStatement',
  method: 'post',
  data
})

/**
 * 6.36	微信支付宝对账单下载
 * @author 黄开亮
 * @date 2021年4月9日 22点38分
 */	
export const ydWeChatAlipayBillPayment = data =>
request({
  url: '/yd/snh/weChatAlipayBillPayment',
  method: 'post',
  data
})

/**
 * 6.34	出金交易请求
 * @author 黄开亮
 * @date 2021年4月9日 22点38分
 */	
export const ydCashTransactionRequest = data =>
request({
  url: '/yd/snh/cashTransactionRequest',
  method: 'post',
  data
})

/**
 * 6.33	内转交易请求
 * @author 黄开亮
 * @date 2021年4月9日 22点38分
 */	
export const ydInternalTransferTransactionRequest = data =>
request({
  url: '/yd/snh/internalTransferTransactionRequest',
  method: 'post',
  data
})

/**
 * 6.23	批量授权扣款结果查询
 * @author 黄开亮
 * @date 2021年4月9日 22点38分
 */	
export const ydBatchAuthorizationDeductionResultQuery = data =>
request({
  url: '/yd/snh/batchAuthorizationDeductionResultQuery',
  method: 'post',
  data
})

/**
 * 6.22	批量授权扣款
 * @author 黄开亮
 * @date 2021年4月9日 22点38分
 */	
export const ydBatchAuthorizedDeduction = data =>
request({
  url: '/yd/snh/batchAuthorizedDeduction',
  method: 'post',
  data
})

/**
 * 6.14	网上K码支付—验证码重发
 * @author 黄开亮
 * @date 2021年4月9日 22点38分
 */	
export const ydOnlineKCodePaymentVerificationCodeRetransmission = data =>
request({
  url: '/yd/snh/OnlineKCodePaymentVerificationCodeRetransmission',
  method: 'post',
  data
})

/**
 * 6.12	网上K码支付—账单发送
 * @author 黄开亮
 * @date 2021年4月9日 22点38分
 */	
export const ydOnlineKcodePaymentBillSending = data =>
request({
  url: '/yd/snh/OnlineKcodePaymentBillSending',
  method: 'post',
  data
})

/**
 * 6.6	单笔退款
 * @author 黄开亮
 * @date 2021年4月9日 22点38分
 */	
export const ydSingleRefund = data =>
request({
  url: '/yd/snh/singleRefund',
  method: 'post',
  data
})

/**
 * 6.13	网上K码支付—支付请求
 * @author 黄开亮
 * @date 2021年4月9日 22点29分
 */	
export const ydOnlineKCodePaymentPaymentRequest = data =>
request({
  url: '/yd/snh/OnlineKCodePaymentPaymentRequest',
  method: 'post',
  data
})

/**
 * 6.3	支付请求
 * 6.3.2	方式2：通过页面传参提交表单方式访问农行支付平台服务
 * @author 黄开亮
 * @date 2021年4月9日 22点20分
 */	
export const ydPaymentRequestTwo = data =>
request({
  url: '/yd/snh/paymentRequestTwo',
  method: 'post',
  data
})

/**
 *  6.3	支付请求
 * 6.3.1	方式1：通过与农行服务器建立连接访问农行支付平台服务
 * 生成连接可行
 * @author 黄开亮
 * @date 2021年3月21日 21点02分
 */	
export const ydPaymentRequest = data =>
request({
  url: '/yd/snh/paymentRequest',
  method: 'post',
  data
})

/**
 *  5、第三方交易渠道订单同步
 * @author 黄开亮
 * @date 2021年3月21日 21点02分
 */	
export const ydBatchRegisterRequest = data =>
request({
  url: '/yd/snh/batchRegisterRequest',
  method: 'post',
  data
})

/**
 *  4、第三方交易渠道订单确认
 * @author 黄开亮
 * @date 2021年3月21日 20点48分
 */	
export const ydThirdConfirmSendMQOrderRequest = data =>
request({
  url: '/yd/snh/thirdConfirmSendMQOrderRequest',
  method: 'post',
  data
})

/**
 *  3、第三方POS订单登记
 * @author 黄开亮
 * @date 2021年3月21日 20点32分
 */	
export const ydRegisterPOSOrderRequest = data =>
request({
  url: '/yd/snh/registerPOSOrderRequest',
  method: 'post',
  data
})

/**
 *  2、查询POS（二级）商户T日清算金额
 * @author 黄开亮
 * @date 2021年3月21日 20点21分
 */	
export const ydQuerySubMerTdaySettleRequest = data =>
request({
  url: '/yd/snh/querySubMerTdaySettleRequest',
  method: 'post',
  data
})

/**
 *  1、第三方POS对账单下载
 * @author 黄开亮
 * @date 2021年3月18日 18点43分
 */	
export const ydPOSThirdFileDownloadRequest = data =>
request({
  url: '/yd/snh/pOSThirdFileDownloadRequest',
  method: 'post',
  data
})

/**
 *  6.46 二级商户迁移
 * @author 黄开亮
 * @date 2021年3月18日 18点34分
 */	
export const ydSecondaryBusinessMigration = data =>
request({
  url: '/yd/snh/SecondaryBusinessMigration',
  method: 'post',
  data
})

/**
 *  6.42	出金交易查询
 * @author 黄开亮
 * @date 2021年3月17日 18点16分
 */	
export const ydDepositTransactionInquiry = data =>
request({
  url: '/yd/snh/depositTransactionInquiry',
  method: 'post',
  data
})

/**
 *  6.40	鉴权交易结果查询（不再支持）
 * @author 黄开亮
 * @date 2021年3月17日 18点13分
 */	
export const ydAuthenticationQuery = data =>
request({
  url: '/yd/snh/authenticationQuery',
  method: 'post',
  data
})

/**
 *  6.38	电子回单下载
 * @author 黄开亮
 * @date 2021年3月17日 18点04分
 */	
export const ydElectronicReceiptDownload = data =>
request({
  url: '/yd/snh/electronicReceiptDownload',
  method: 'post',
  data
})

/**
 * 6.27	预授权确认/取消
 * @author 黄开亮
 * @date 2021年3月17日 17点58分
 */	
export const ydPreAuthorizationConfirmationCancellation = data =>
request({
  url: '/yd/snh/preAuthorizationConfirmationCancellation',
  method: 'post',
  data
})

/**
 * 6.40	平台商户对账单下载
 * @author 黄开亮
 * @date 2021年3月17日 17点54分
 */	
export const ydPlatformMerchantStatementDownload = data =>
request({
  url: '/yd/snh/platformMerchantStatementDownload',
  method: 'post',
  data
})

/**
 * 6.11	对账单查询
 * @author 黄开亮
 * @date 2021年3月17日 17点49分
 */	
export const ydStatementQuery = data =>
request({
  url: '/yd/snh/statementQuery',
  method: 'post',
  data
})

/**
 * 6.10	交易明细查询
 * @author 黄开亮
 * @date 2021年3月17日 17点42分
 */	
export const ydTransactionDetailEnquiry = data =>
request({
  url: '/yd/snh/transactionDetailEnquiry',
  method: 'post',
  data
})

/**
 * 6.19	授权支付解约
 * @author 黄开亮
 * @date 2021年3月17日 17点17分
 */
export const ydTerminationOfAuthorizedPayment = data =>
request({
  url: '/yd/snh/terminationOfAuthorizedPayment',
  method: 'post',
  data
})

/**
 * 6.20	授权支付签约/解约结果查询
 * @author 黄开亮
 * @date 2021年3月17日 17点07分
 */
export const ydAuthorizedPaymentSigningCancelingResultQuery = data =>
request({
  url: '/yd/snh/authorizedPaymentSigningCancelingResultQuery',
  method: 'post',
  data
})

/**
 * 6.44	掌银被扫支付请求
 * @author 黄开亮
 * @date 2021年3月4日 18点07分
 */
export const ydSnhPalmBankIsSweptToPay = data =>
request({
  url: '/yd/snh/palmBankIsSweptToPay',
  method: 'post',
  data
})

/**
 * 6.32	二级商户信息同步（不再支持）
 * @author 黄开亮
 * @date 2021年3月4日 17点19分
 */
export const ydSnhRegSubMerchantInfoRequestOld = data =>
request({
  url: '/yd/snh/regSubMerchantInfoRequestOld',
  method: 'post',
  data
})

/**
 * 6.48	二级商户信息同步（新）
 * @author 黄开亮
 * @date 2021年1月29日 17点19分
 */
export const secondaryMerchantInformationSynchronizationNew = data =>
request({
  url: '/yd/snh/secondaryMerchantInformationSynchronizationNew',
  method: 'post',
  data
})

/**
 * 二级商户信息保存
 * @author 黄开亮
 * @date 2021年3月15日 17点16分
 */
export const SecondaryMerchantsSynchronizeNew = data =>
request({
  url: '/yd/snh/SecondaryMerchantsSynchronizeNew',
  method: 'post',
  data
})

 /**
  * 市农行 二级商户信息查看
  * @author 黄开亮
  * @date 2021年1月30日 9点31分
  * */
 export const getSnhMerchantPage = params =>
 request({
   url: '/yd/snh/getSnhMerchantPage',
   method: 'get',
   params
 })
 
 /**
  * 市农行 交易明细
  * @author 黄开亮
  * @date 2021年3月23日 20点31分
  * */
 export const getSnhTransactionDetailsPage = params =>
 request({
   url: '/snhTransactionDetails/getSnhTransactionDetailsPage',
   method: 'get',
   params
 })
 
 /**
  * 市农行 交易对账单
  * @author 黄开亮
  * @date 2021年3月23日 20点47分
  * */
 export const getSnhTransactionStatementPage = params =>
 request({
   url: '/snhTransactionStatement/getSnhTransactionStatementPage',
   method: 'get',
   params
 })
 
 /**
  * 市农行 二级商户标记删除
  * @author 黄开亮
  * @date 2021年1月30日 12点07分
  * */
 export const delSnhMerchantPage = params =>
 request({
   url: '/yd/snh/delSnhMerchantPage',
   method: 'get',
   params
 })
 /**
  * 6.49	二级商户状态变更请求
  * @author 黄开亮
  * @date 2021年1月30日 12点51分
  */
 export const secondaryMerchantStatusChangeRequest = data =>
 request({
   url: '/yd/snh/secondaryMerchantStatusChangeRequest',
   method: 'post',
   data
 })
 /**
  * 6.5	二级商户签约确认
  * @author 黄开亮
  * @date 2021年1月30日 13点16分
  */
 export const signingConfirmationOfSecondaryMerchants = data =>
 request({
   url: '/yd/snh/signingConfirmationOfSecondaryMerchants',
   method: 'post',
   data
 })
 /**
  * 6.45	二级商户信息查询
  * @author 黄开亮
  * @date 2021年1月30日 13点16分
  */
 export const secondaryMerchantInformationQuery = data =>
 request({
   url: '/yd/snh/secondaryMerchantInformationQuery',
   method: 'post',
   data
 })
 /**
  * 6.35	二级商户余额查询
  * @author 黄开亮
  * @date 2021年1月30日 14点24分
  */
 export const secondaryMerchantBalanceQuery = data =>
 request({
   url: '/yd/snh/secondaryMerchantBalanceQuery',
   method: 'post',
   data
 })
 /**
  * 6.53	二级商户签约短信验证码重发
  * @author 黄开亮
  * @date 2021年1月30日 15点04分
  */
 export const sendMobileMessageForSubMerRequest = data =>
 request({
   url: '/yd/snh/sendMobileMessageForSubMerRequest',
   method: 'post',
   data
 })
 /**
  * 6.26	身份验证（非页面跳转）
  * @author 黄开亮
  * @date 2021年2月01日 21点20分
  */
 export const authenticationNonPageJump = data =>
 request({
   url: '/yd/snh/authenticationNonPageJump',
   method: 'post',
   data
 })
 /**
  * 6.24	身份验证（页面跳转）
  * @author 黄开亮
  * @date 2021年2月01日 21点44分
  */
 export const authenticationPageJump = data =>
 request({
   url: '/yd/snh/authenticationPageJump',
   method: 'post',
   data
 })
 /**
  * 6.15	授权支付签约（银行端）
  * @author 黄开亮
  * @date 2021年2月02日 9点30分
  */
 export const authorizedPaymentSigningBankEnd = data =>
 request({
   url: '/yd/snh/authorizedPaymentSigningBankEnd',
   method: 'post',
   data
 })
 /**
  * 6.16	授权支付签约（商户端）—申请
  * @author 黄开亮
  * @date 2021年2月02日 16点31分
  */
 export const authorizedPaymentSigningMerchantSideApplication = data =>
 request({
   url: '/yd/snh/authorizedPaymentSigningMerchantSideApplication',
   method: 'post',
   data
 })
 /**
  * 6.17	授权支付签约（商户端）—确认
  * @author 黄开亮
  * @date 2021年2月02日 21点59分
  */
 export const authorizedPaymentSigningMerchantSideConfirmation = data =>
 request({
   url: '/yd/snh/authorizedPaymentSigningMerchantSideConfirmation',
   method: 'post',
   data
 })
 /**
  * 6.18	授权支付签约（商户端）—验证码重发
  * @author 黄开亮
  * @date 2021年2月02日 22点11分
  */
 export const authorizedPaymentSigningMerchantSideVerificationCodeResend = data =>
 request({
   url: '/yd/snh/authorizedPaymentSigningMerchantSideVerificationCodeResend',
   method: 'post',
   data
 })
/** 市农行end **/


/**
 * 二维码管理 begin
 * */
 
 /**
  * 二维码管理
  * @author 黄开亮
  * @date 2021年2月19日 11点55分
  * */
 export const getAQRCodeListPage = params =>
 request({
   url: '/aQrCode/getAQRCodeListPage',
   method: 'get',
   params
 })
 
 /**
  * 二维码
  * 添加或修改
  * @author 黄开亮
  * @date 2021年2月19日 15点26分
  */
 export const aQrCodeSaveOrUpdate = data =>
 request({
   url: '/aQrCode/saveOrUpdate',
   method: 'post',
   data
 })
 
 /**
  * 二维码logo管理
  * @author 黄开亮
  * @date 2021年2月19日 11点55分
  * */
 export const getAQRCodeLogoListPage = params =>
 request({
   url: '/aQrCodeLogo/getAQRCodeLogoListPage',
   method: 'get',
   params
 })
 /**
  * 二维码logo管理
  * 新增或修改
  * @author 黄开亮
  * @date 2021年2月20日 11点46分
  * */
 export const aQrCodeLogoSaveOrUpdate = data =>
 request({
   url: '/aQrCodeLogo/saveOrUpdate',
   method: 'post',
   data
 })
 /**
  * 二维码图片logo
  * 删除
  * @author 黄开亮
  * @date 2021年2月19日 11点55分
  * */
 export const delAQrCodeLogo = params =>
 request({
   url: '/aQrCodeLogo/del',
   method: 'get',
   params
 })
 
 /**
  * 二维码列表
  * 删除
  * @author 黄开亮
  * @date 2021年3月25日 14点06分
  * */
 export const aQrCodeDel = params =>
 request({
   url: '/aQrCode/aQrCodeDel',
   method: 'get',
   params
 })
 /**
  * 生成二维码
  * logo选中
  * @author 黄开亮
  * @date 2021年2月20日 18点04分
  * */
 export const aQrCodeLogoqSelection = data =>
 request({
   url: '/aQrCodeLogo/qRCodeLogoSelection',
   method: 'post',
   data
 })
/**
 * 二维码管理 end
 * */ 
 

/**
 * 客如云 begin
 * */
 
 /**
  * 订单详情
  * */
 export const getKryOrderInquiryDetail = params =>
 request({
   url: '/kry/demo/order/detail',
   method: 'get',
   params
 })
 
 /**
  * 查看订单列表
  * */
 export const getKryOrderInquiry = params =>
 request({
   url: '/kry/demo/order/orderInquiry',
   method: 'get',
   params
 })
 
 /**
  * 客如云 end
  * */

/**
 * 同步最近三天的流水
 * @author 黄开亮
 * @date 2021年1月27日 14点36分
 */
export const getSynTheFlowOfTheLastThreeDays = data =>
request({
  url: '/nhTransactionFlow/getSynTheFlowOfTheLastThreeDays',
  method: 'post',
  data
})

/**
 * 同步全部的流水
 * @author 黄开亮
 * @date 2021年1月27日 14点40分
 */
export const getSynAllStreams = data =>
request({
  url: '/nhTransactionFlow/getSynAllStreams',
  method: 'post',
  data
})

/**
 * 检查刷脸记录与流水不平原因
 * @author 黄开亮
 * @date 2021年1月28日 14点25分
 */
export const getCheckTheFaceBrushingRecordAndTheCauseOfUnevenWaterFlow = data =>
request({
  url: '/nhTransactionFlow/getCheckTheFaceBrushingRecordAndTheCauseOfUnevenWaterFlow',
  method: 'post',
  data
})

/**
 * 农行刷脸记录与交易流水
 * 分页查看
 * @author 黄开亮
 * @date 2021年1月22日 13点45分
 */
export const getNhTransactionAndFaceRecordList = params =>
request({
  url: '/nhTransactionAndFaceRecord/getNhTransactionAndFaceRecordList',
  method: 'get',
  params
})

/**
 * 农行刷脸记录与交易流水
 * 月份统计
 * 分页查看
 * @author 黄开亮
 * @date 2021年3月19日 10点07分
 */
export const getNhTransactionAndFaceMonthlyStatisticsList = params =>
request({
  url: '/nhTransactionAndFaceRecord/getNhTransactionAndFaceMonthlyStatisticsList',
  method: 'get',
  params
})

/**
 * 海康威视
 * 人脸识别记录
 * 分页查看
 * @author 黄开亮
 * @date 2021年1月6日 10点33分
 */
export const getHkFaceRecognitionRecordList = params =>
request({
  url: '/hkFaceRecognitionRecord/getHkFaceRecognitionRecordList',
  method: 'get',
  params
})

/**
 * 银达
 * 农行食堂用户
 * 分页查看
 * @author 黄开亮
 * @date 2020年12月11日 16点25分
 */
export const getNhUser = params =>
request({
  url: '/nhUser/getNhUser',
  method: 'get',
  params
})


/**
 * 银达
 * 日志与流水对比某一天
 * 差异数据
 * 用作流水逆踢刷脸记录
 * @author 黄开亮
 * @date 2020年12月10日 19点56分
 */
export const journalAndRunningWaterCaSupplementaryIdentificationRecordKickBack = params =>
request({
  url: '/nhFaceRecognitionRecord/journalAndRunningWaterCaSupplementaryIdentificationRecordKickBack',
  method: 'get',
  params
})

/**
 * 银达
 * 日志与流水对比某一天
 * 差异数据
 * 用作流水反补刷脸记录
 * @author 黄开亮
 * @date 2020年12月10日 19点12分
 */
export const journalAndRunningWaterCaSupplementaryIdentificationRecord = params =>
request({
  url: '/nhFaceRecognitionRecord/journalAndRunningWaterCaSupplementaryIdentificationRecord',
  method: 'get',
  params
})

/**
 * 银达
 * 农行餐厅
 * 用户余额
 * @author 黄开亮
 * @date 2020年12月02日 20点40分
 */
export const getUserbalanceRecord = params =>
request({
  url: '/nhUserbalanceRecord/getUserbalanceRecord',
  method: 'get',
  params
})

/**
 * 银达
 * 农行餐厅
 * 交易入账对比差异excel导出
 * @author 黄开亮
 * @date 2020年11月30日 19点29分
 */
export const getFlowingTransactionEntry = params =>
request({
  url: '/nhTransactionFlow/getFlowingTransactionEntry',
  method: 'get',
  params
})

/**
 * 银达
 * 农行餐厅
 * 交易时间与入账时间月份查看设置
 * 改变
 * @author 黄开亮
 * @date 2020年11月28日 13点03分
 */
export const getTransactionAndEntryTimeSetUpChange = params =>
request({
  url: '/nhTransactionFlow/getTransactionAndEntryTimeSetUpChange',
  method: 'get',
  params
})

/**
 * 银达
 * 农行餐厅
 * 交易时间与入账时间月份查看设置
 * @author 黄开亮
 * @date 2020年11月28日 13点03分
 */
export const getTransactionAndEntryTimeSetUpSee = params =>
request({
  url: '/nhTransactionFlow/getTransactionAndEntryTimeSetUpSee',
  method: 'get',
  params
})

/**
 * 银达
 * 农行餐厅
 * 交易流水
 * @author 黄开亮
 * @date 2020年11月25日 16点53分
 */
export const getNhTransactionFlowListPage = params =>
request({
  url: '/nhTransactionFlow/getNhTransactionFlowListPage',
  method: 'get',
  params
})

/**
 * 银达
 * 农行餐厅
 * 设备人脸识别记录
 * @author 黄开亮
 * @date 2020年11月25日 16点34分
 */
export const getListnhFaceRecognitionPage = params =>
request({
  url: '/nhFaceRecognitionRecord/getListnhFaceRecognitionPage',
  method: 'get',
  params
})

/**
 * 银达产品
 * 详情
 * 标记删除
 * @author 黄开亮
 * @date 2020年10月16日 15点2&分
 */
export const getDelYDProductOrDetail = params =>
request({
  url: '/ydProduct/getDelYDProductOrDetail',
  method: 'get',
  params
})


/**
 * 银达产品详情
 * 新增或编辑 
 */
export const yDProductDetailAddOrEdit = data =>
    request({
        url: '/ydProductDetail/yDProductDetailAddOrEdit',
        method: 'post',
        data
    })

/**
 * 银达产品详情
 * @author 黄开亮
 * @date 2020年10月14日 16点36分
 */
export const getYDProductDetail = params =>
request({
  url: '/ydProductDetail/getYDProductDetail',
  method: 'get',
  params
})

/**
 * 银达产品列表分页
 * @author 黄开亮
 * @date 2020年10月14日 15点53分
 */
export const getYDProductListPage = params =>
request({
  url: '/ydProduct/getYDProductListPage',
  method: 'get',
  params
})

/**
 * 银达产品
 * 产品详情数据抓取
 * @author 黄开亮
 * @date 2020年10月14日 15点41分
 */
export const getGrab = params =>
request({
  url: '/ydProduct/getGrab',
  method: 'get',
  params
})

/**
 * 银达
 * 农行餐厅短信发送记录
 * @author 黄开亮
 * @date 2020年10月10日 10点44分
 */
export const getCanteenSmsListPage = params =>
request({
  url: '/nhCanteenSmsRecord/getCanteenSmsListPage',
  method: 'get',
  params
})

 /**
 * 单词图片检查并下载
 * */
export const getEnWordInspect = params =>
request({
  url: '/enWord/inspect',
  method: 'get',
  params
})

 /**
 * 某个单词包详情
 * */
export const getEnWordPackageDetail = params =>
request({
  url: '/enWordPackage/getEnWordPackageDetail',
  method: 'get',
  params
})

/**
 * 单词包下关联单词关系删除
 * */
export const removeEnWordRePackage = data =>
    request({
        url: '/enWordRePackage/removeEnWordRePackage',
        method: 'delete',
		data
    })
	
/**
 * 单词关联包包增加或修改
 * */
export const saveOrEditEnWordRePackage = data =>
    request({
        url: '/enWordRePackage/saveOrEditEnWordRePackage',
        method: 'post',
        data
    })
	
/**
 * 单词包下绑定的单词列表分页
 * */
export const getEnWordPackageItem = params =>
  request({
    url: '/enWordPackage/getEnWordPackageItem',
    method: 'get',
    params
  })

/**
 * 单词包删除
 * */
export const removeEnWordPackage = data =>
    request({
        url: '/enWordPackage/removeEnWordPackage',
        method: 'delete',
		data
    })

/**
 * 单词包增加或修改
 * */
export const saveOrEditEnWordPackage = data =>
    request({
        url: '/enWordPackage/saveOrEditEnWordPackage',
        method: 'post',
        data
    })

/**
 * 单词包-获取列表
 * */
export const getEnWordPackageListPage = params =>
  request({
    url: '/enWordPackage/getEnWordPackageListPage',
    method: 'get',
    params
  })


/**
 * 标记删除单词
 * */
export const getEnwordMarkDelete = (id) =>
    request({
        url: '/enWord/markDelete?id='+id,
        method: 'get',
    })

/**
 * 新增单词
 * */
export const addOrEditWordform = data =>
    request({
        url: '/enWord/saveOrEditWord',
        method: 'post',
        data
    })


/**
 * 单词管理-获取列表
 * */
export const getEnWordPage = params =>
  request({
    url: '/enWord/listEnWordPage',
    method: 'get',
    params
  })

/**
 * 角色权限 
 * 分页查看
 * @author 黄开亮
 * @date 2021年3月3日 16点29分
 */
export const getUcManagePage = params =>
request({
  url: '/uc/manage/up/ucManagePage',
  method: 'get',
  params
})

/**
 * 管理后台
 * 菜单列表
 * 分页查询 
 * @author 黄开亮
 * @date 2021年3月4日 11点18分
 */
export const getUcAuthModuleAuthPage = params =>
request({
  url: '/uc/module/auth/moduleAuthPage',
  method: 'get',
  params
})

/**
 * 管理后台
 * 菜单列表
 * 新增菜单
 * @author 黄开亮
 * @date 2021年3月9日 9点25分
 * */
export const addUcModuleAuth = (data) =>
    request({
        url: '/uc/module/auth',
        method: 'post',
        data
})

/**
 * 管理后台
 * 角色权限
 * 新增角色
 * @author 黄开亮
 * @date 2021年3月9日 11点49分
 * */
export const addUcManageUp = (data) =>
    request({
        url: '/uc/manage/up',
        method: 'post',
        data
})

/**
 * 管理后台
 * 角色权限
 * 修改角色
 * @author 黄开亮
 * @date 2021年3月9日 9点28分
 * */
export const updateUcManageUp = (data) =>
    request({
        url: '/uc/manage/up',
        method: 'put',
        data
    })

/**
 * 管理后台
 * 菜单列表
 * 查询所有菜单列表id、name
 * @author 黄开亮
 * @date 2021年3月9日 9点56分
 * */
export const queryUcModuleAuthListIdName = params =>
    request({
        url: '/uc/module/auth/listIdName',
        method: 'get',
        params
})

/**
 * 管理后台
 * 菜单列表
 * 修改菜单
 * @author 黄开亮
 * @date 2021年3月9日 9点28分
 * */
export const updateUcModuleAuth = (data) =>
    request({
        url: '/uc/module/auth',
        method: 'put',
        data
    })
		
/**
 * 管理后台
 * 角色权限
 * 批量删除角色
 * @author 黄开亮
 * @date 2021年3月9日 11点16分
 * */
export const delUcManageUpRe = data =>
    request({
        url: '/uc/manage/up/re',
        method: 'delete',
        data
    })	
			

/**
 * 管理后台
 * 角色权限
 * 批量删除菜单
 * @author 黄开亮
 * @date 2021年4月24日 16点45分
 * */
export const delUcModuleAuth = data =>
    request({
        url: '/uc/module/auth',
        method: 'delete',
        data
    })			

/**
 * 管理后台
 * 查询菜单树
 * @author 黄开亮
 * @date 2021年3月4日 11点18分
 * */
export const ucAuthModuleAuthTree = (data) =>
    request({
        url: '/uc/module/auth/moduleAuthTree',
        method: 'post',
        data
})

/**
 * 寻人审核失败
 * */
export const searchPersonAuditFailed = (data) =>
    request({
        url: '/search/person/audit/failed',
        method: 'put',
        data
    })

/**
 * 寻人审核通过
 * */
export const searchPersonAuditSuccess = (id) =>
    request({
        url: '/search/person/audit/success/'+id,
        method: 'put',
    })

/**
 * 寻人关键字
 * */
export const getSearchPersonType = (type) =>
    request({
        url: '/search/person/type?type='+type,
        method: 'get',
    })

/**
 * 寻人查看详情
 * */
export const getSearchPerson = (id) =>
    request({
        url: '/search/person/'+id,
        method: 'get',
    })

/**
 * 寻人列表
 * */
export const getSearchPersonWebPage = params =>
    request({
        url: `/search/person/web`,
        method: 'get',
        params
    })

/**
 * 删除平台礼物
 * */
export const delGiftPlatform = data =>
    request({
        url: '/gift/platform?platformGiftIdList',
        method: 'delete',
        data
    })

/**
 * 更新平台礼物
 * */
export const editGiftPlatform = data =>
    request({
        url: '/gift/platform',
        method: 'put',
        data
    })

/**
 * 设置平台礼物兑换比例
 * */
export const getGiftPlatformExchangeRatioPut = params =>
    request({
        url: '/gift/platform/exchange-ratio',
        method: 'put',
        params
    })


/**
 * 查询平台礼物兑换比例
 * */
export const getGiftPlatformExchangeRatio = () =>
    request({
        url: '/gift/platform/exchange-ratio',
        method: 'get',
    })

/**
 * 新增平台礼物
 * */
export const addGiftPlatform = data =>
    request({
        url: '/gift/platform',
        method: 'post',
        data
    })

/**
 * 分页查询平台礼物列表
 * */
export const giftPlatformPage = params =>
    request({
        url: `/gift/platform/page`,
        method: 'get',
        params
    })

/**
 * 提现设置
 * */
export const walletWithdrawApplyConfig = data =>
    request({
        url: '/wallet/withdraw/apply/config',
        method: 'put',
        data
    })

/**
 * 提现申请审核
 * */
export const walletWithdrawApplyAudit = data =>
    request({
        url: '/wallet/withdraw/apply/audit',
        method: 'put',
        data
    })

/**
 * 分页查询提现列表
 * */
export const getWalletWithdrawApplyPage = params =>
    request({
        url: `/wallet/withdraw/apply/page`,
        method: 'get',
        params
    })

/**
 * 分页查询收支明细
 * */
export const getWalletIncomeExpendPage = params =>
    request({
        url: `/wallet/income-expend/page`,
        method: 'get',
        params
    })

/**
 * 分页查询用户钱包
 * */
export const getWalletPage = params =>
    request({
        url: `/wallet/page`,
        method: 'get',
        params
    })


/**
 * 账户密码登录
 * */
export const login = data =>
  request({
    url: '/user/backLand',
    method: 'post',
    data
  })

/**
 * 根据token获取用户信息
 * */
export const getToken = data =>
    request({
        url: '/token/getToken',
        method: 'post',
        data
    })

/**
 * 修改密码
 * */
export const setUserPWD = data =>
    request({
        url: '/user/setUserPWD',
        method: 'post',
        data
})

/**
 * 代理商权限设置查看
 * */
export const getUserPerm = (userId) =>
    request({
        url: `/user/getUserPerm?userId=${userId}`,
        method: 'get'
    })

/**
 * 角色权限
 * 用户管理
 * 新增用户
 * */
export const backNewUsers = data =>
    request({
        url: '/user/backNewUsers',
        method: 'post',
        data
    })

/**
 * 新增或修改用户角色
 * */
export const addOrEditUserRole = data =>
    request({
        url: '/user/userRole/addOrEditForm',
        method: 'post',
        data
    })

/**
 * 角色权限
 * 用户管理
 * 系统权限设置
 * */
export const getSystemPermSettings = params =>
    request({
        url: '/auser/getSystemPermSettings',
        method: 'get',
		params
    })
	
	/**
	 * 角色权限
	 * Tree
	 * 用户管理
	 * 系统权限设置
	 * */
	export const getSystemPermTreeSettings = params =>
	    request({
	        url: '/auser/getSystemPermTreeSettings',
	        method: 'get',
			params
	    })

/**
 * 角色管理
 * */
export const getUserRolePage = params =>
    request({
        url: `/user/role/page`,
        method: 'get',
        params
})

/**
 * 角色与功能绑定
 * */
export const addUserRoleFun = data =>
    request({
        url: '/user/roleFun',
        method: 'post',
        data
})

/**
 * 新增角色
 * */
export const addUserRole = data =>
    request({
        url: '/user/role/',
        method: 'post',
        data
    })

/**
 * 编辑角色
 * */
export const editUserRole = data =>
    request({
        url: '/user/role/',
        method: 'put',
        data
})

/**
 * 删除角色
 * */
export const delUserRole = data =>
    request({
        url: '/user/role/',
        method: 'delete',
        data
    })

/**
 * 根据token查询用户数据
 * */
export const getUserDataByToken = () =>
  request({
    url: `/user/getToken/?token=${localStorage.token}`,
    method: 'get'
  })

/**
 * 权限管理
 * 用户管理
 * */
export const getRolePermPage = params =>
    request({
        url: '/user/getRolePermPage',
        method: 'get',
        params
    })

/**
 * 角色列表
 * */
export const getRoleList = () =>
    request({
        url: '/user/role/list',
        method: 'get',
})

/**
 * 获取地区树
 * */
export const getAreaTree = () =>
  request({
    url: '/amap/tree',
    method: 'get',
  })

/**
 * 获取地区树(只有省市)
 * */
export const getAreaTreeOnlyCityProvince = () =>
  request({
    url: '/amap/treeProvinceAndCityNode',
    method: 'get',
  })

/**
 * 广告管理-获取广告行业树
 * */
export const getAdIndustryTree = () =>
  request({
    url: '/ad/industry/tree',
    method: 'get',
  })

/**
 * 广告管理-获取广告审核分页
 * */
export const getAdAuthPage = params =>
  request({
    url: '/ad/advertising/page/audit',
    method: 'get',
    params
  })

/**
 * 广告管理-获取奖励规则
 * */
export const setAdAuth = data =>
  request({
    url: '/ad/advertising/audit',
    method: 'put',
    data
  })

/**
 * 广告管理-发布广告
 * */
export const addAd = data =>
  request({
    url: '/ad/advertising',
    method: 'post',
    data
  })

/**
 * 广告管理-删除广告
 * */
export const delAd = id =>
  request({
    url: `/ad/advertising/${id}`,
    method: 'delete',
  })

/**
 * 广告管理-获取广告详情
 * */
export const getAdMsg = id =>
  request({
    url: `/ad/advertising/web/detail/${id}`,
    method: 'get',
  })

/**
 * 广告管理-获取广告详情
 * */
export const getAdMinePage = params =>
  request({
    url: '/ad/advertising/page/mine',
    method: 'get',
    params
  })

/**
 * 广告管理-获取广告统计信息
 * */
export const getAdMsgStatistics = id =>
  request({
    url: `/ad/advertising/data-statistic/${id}`,
    method: 'get',
  })

/**
 * 广告管理-获取奖励规则
 * */
export const getAdRuleList = () =>
  request({
    url: '/ad/red-packet-rule/list',
    method: 'get',
  })

/**
 * 广告管理-获取奖励规则
 * */
export const getAdBeforeCondition = () =>
  request({
    url: '/ad/advertising/precondition',
    method: 'get',
  })

/**
 * 广告管理-结束投放
 * */
export const setAdClose = id =>
  request({
    url: `/ad/advertising/close/${id}`,
    method: 'put',
  })

/**
 * 广告设置-获取设置
 * */
export const getAdSettings = () =>
  request({
    url: '/ad/config',
    method: 'get',
  })

/**
 * 广告设置-修改设置
 * */
export const setAdSettings = data =>
  request({
    url: '/ad/config',
    method: 'post',
    data
  })

/**
 * 用户管理-大V认证-获取列表
 * */
export const getUserVPage = params =>
  request({
    url: '/vip/apply/list',
    method: 'get',
    params
  })

/**
 * 用户管理-大V认证-审核类型
 * */
export const setUserVAuth = data =>
  request({
    url: '/vip/apply',
    method: 'post',
    data
  })

/**
 * 用户管理-大V认证-获取认证类型
 * */
export const getUserVAuthType = () =>
  request({
    url: '/vipTag',
    method: 'get',
  })

/**
 * 用户管理-大V认证-新增认证类型
 * */
export const addUserVAuthType = data =>
  request({
    url: '/vipTag',
    method: 'post',
    data
  })

/**
 * 用户管理-大V认证-编辑认证类型
 * */
export const setUserVAuthType = data =>
  request({
    url: '/vipTag',
    method: 'put',
    data
  })

/**
 * 用户管理-大V认证-删除认证类型
 * */
export const delUserVAuthType = id =>
  request({
    url: `/vipTag/delete/${id}`,
    method: 'delete',
  })

/**
 * 用户管理-大V认证-审核申请
 * */
export const setUserVAuthApply = data =>
  request({
    url: '/vip/apply/check',
    method: 'put',
    data
  })

/**
 * 敏感词-获取分页
 * */
export const getSensitivePage = params =>
  request({
    url: '/sensitive-word/page',
    method: 'get',
    params
  })

/**
 * 敏感词-删除
 * */
export const delSensitive = id =>
  request({
    url: '/sensitive-word',
    method: 'delete',
    data: {sensitiveWordIdList: [id]}
  })

/**
 * 敏感词-编辑
 * */
export const setSensitive = data =>
  request({
    url: '/sensitive-word',
    method: 'put',
    data
  })

/**
 * 敏感词-新增
 * */
export const addSensitive = data =>
  request({
    url: '/sensitive-word',
    method: 'post',
    data
  })

/**
 * 举报管理-获取分页
 * */
export const getReportPage = params =>
  request({
    url: '/complain/records/list',
    method: 'get',
    params
  })

/**
 * 举报管理-获取详情
 * */
export const getReportMsg = id =>
  request({
    url: `/complain/records/${id}`,
    method: 'get',
  })

/**
 * 举报管理-处理
 * */
export const setReport = data =>
  request({
    url: '/complain/records/deal',
    method: 'put',
    data
  })

/**
 * 举报管理-获取内容分类
 * */
export const getReportContentTypeList = params =>
  request({
    url: '/complain/type/list',
    method: 'get',
    params
  })

/**
 * 举报管理-添加内容分类
 * */
export const addReportContentType = data =>
  request({
    url: '/complain/type',
    method: 'post',
    data
  })

/**
 * 举报管理-编辑内容分类
 * */
export const setReportContentType = data =>
  request({
    url: '/complain/type',
    method: 'put',
    data
  })

/**
 * 举报管理-删除内容分类
 * */
export const delReportContentType = id =>
  request({
    url: `/complain/type/${id}`,
    method: 'delete'
  })


/**
 * 用户管理
 * 银达用户列表
 * */
export const getYDUserPage = params =>
  request({
    url: '/ydUser/listUserPage',
    method: 'get',
    params
  })
  
/**
 * 用户管理-用户列表
 * */
export const getUserPage = params =>
  request({
    url: '/user/listUserPage',
    method: 'get',
    params
  })

/**
 * 用户管理-获取用户详情
 * */
export const getUserMsg = userId =>
  request({
    url: `/user/getUserDetailById?userId=${userId}`,
    method: 'get',
  })

/**
 * 用户管理-获取用户邀请详情
 * */
export const getUserInviteMsg = userId =>
  request({
    url: `/user/getInvitationInfo?userId=${userId}`,
    method: 'get',
  })

/**
 * 用户管理-获取用户广告权限
 * */
export const getUserAdAuth = id =>
  request({
    url: `/user/getUserAdAuthorityLegal?userId=${id}`,
    method: 'get',
  })

/**
 * 用户管理-设置用户广告权限
 * */
export const setUserAdAuth = data =>
  request({
    url: '/user/setUpUserAdAuthorityLegal',
    method: 'post',
    data
  })

/**
 * 用户管理-获取邀请好友设置
 * */
export const getUserFriend = () =>
  request({
    url: '/user/invite/rule/getInvitationRules',
    method: 'get',
  })

/**
 * 用户管理-修改邀请好友设置
 * */
export const setUserFriend = data =>
  request({
    url: '/user/invite/rule/updateInvitationRules',
    method: 'put',
    data
  })

/**
 * 用户管理-获取新用户奖励规则
 * */
export const getUserNewUserRule = () =>
  request({
    url: '/user/invite/rule/getNewUserRewardRule',
    method: 'get',
  })

/**
 * 用户管理-修改新用户奖励规则
 * */
export const setUserNewUserRule = val =>
  request({
    url: `/user/invite/rule/updateNewUserRewardRule?money=${val}`,
    method: 'put',
  })

/**
 * 用户管理-获取代理商树下拉
 * */
export const getAgentTree = () =>
  request({
    url: '/user/pageAgentTree',
    method: 'get',
  })

/**
 * 用户管理-修改状态
 * */
export const setUserStatus = data =>
  request({
    url: '/user/accountProhibit',
    method: 'put',
    data
  })

/**
 * 资讯管理-资讯审核-获取待审核列表
 * */
export const getInformationAuditWaitPage = params =>
  request({
    url: '/information/page/audit/wait',
    method: 'get',
    params
  })

/**
 * 资讯管理-资讯审核-获取待审核列表
 * */
export const getInformationCityTreeByUserRole = () =>
  request({
    url: '/user/getAgentProCity',
    method: 'get',
  })

/**
 * 资讯管理-资讯审核-获取审核未通过列表
 * */
export const getInformationAuditFailedPage = params =>
  request({
    url: '/information/page/audit/failed',
    method: 'get',
    params
  })

/**
 * 资讯管理-资讯审核-获取审核通过列表
 * */
export const getInformationAuditSuccessPage = params =>
  request({
    url: '/information/page/audit/success',
    method: 'get',
    params
  })

/**
 * 资讯管理-资讯审核-查询详情
 * */
export const getInformationAuditMsg = id =>
  request({
    url: `/information/web/${id}`,
    method: 'get',
  })

/**
 * 资讯管理-资讯审核-审核通过
 * */
export const setInformationAuditSuccess = data =>
  request({
    url: '/information/audit/success',
    method: 'put',
    data
  })

/**
 * 资讯管理-资讯审核-审核通过
 * */
export const setInformationAuditFailed = data =>
  request({
    url: '/information/audit/failed',
    method: 'put',
    data
  })

/**
 * 资讯管理-资讯审核-下架
 * */
export const setInformationAuditSoldOut = data =>
  request({
    url: '/information/out/stock',
    method: 'put',
    data
  })

/**
 * 资讯管理-资讯审核-置顶
 * */
export const setInformationAuditTop = data =>
  request({
    url: '/stick',
    method: 'post',
    data
  })

/**
 * 资讯管理-资讯审核-取消置顶
 * */
export const setInformationAuditCancelTop = informationId =>
  request({
    url: `/stick/${informationId}`,
    method: 'delete',
  })

/**
 * 资讯管理-我的资讯
 * */
export const getInformationMinePage = params =>
  request({
    url: '/information/web',
    method: 'get',
    params
  })

/**
 * 资讯管理-删除资讯
 * */
export const delInformationMine = id =>
  request({
    url: `/information/${id}`,
    method: 'delete',
  })

/**
 * 资讯管理-发布资讯
 * */
export const addInformationMine = data =>
  request({
    url: '/information',
    method: 'post',
    data
  })

/**
 * 资讯管理-修改资讯
 * */
export const setInformationMine = data =>
  request({
    url: '/information',
    method: 'put',
    data
  })

/**
 * 资讯管理-查询分类
 * */
export const getInformationClassify = () =>
  request({
    url: '/tags',
    method: 'get',
  })

/**
 * 资讯管理-查询分类中的标签
 * */
export const getInformationTagsByClassify = tagsId =>
  request({
    url: '/label',
    method: 'get',
    params: {tagsId}
  })

/**
 * 代理商-查询分页
 * */
export const getAgentPage = params =>
  request({
    url: '/user/pageAgent',
    method: 'get',
    params
  })

/**
 * 代理商-添加
 * */
export const addAgent = data =>
  request({
    url: '/user/addAgent',
    method: 'post',
    data
  })

/**
 * 代理商-修改
 * */
export const setAgent = data =>
  request({
    url: '/user/editAgent',
    method: 'put',
    data
  })

/**
 * 代理商-查询详情
 * */
export const getAgentMsg = userId =>
  request({
    url: '/user/getAgentDetailById',
    method: 'get',
    params: {userId}
  })

/**
 * 代理商-查询分成比例
 * */
export const getAgentRatio = () =>
  request({
    url: '/user/getAgentAdvertProp',
    method: 'get',
  })

/**
 * 代理商-设置分成比例
 * */
export const setAgentRatio = data =>
  request({
    url: '/user/setUpAgentAdvertProp',
    method: 'post',
    data
  })

/**
 * 视频管理-提交审核
 * */
export const addVideo = data =>
  request({
    url: '/video',
    method: 'post',
    data
  })

/**
 * 视频管理-编辑视频
 * */
export const setVideo = data =>
  request({
    url: '/video',
    method: 'put',
    data
  })

/**
 * 视频管理-获取我的视频
 * */
export const getVideoMinePage = params =>
  request({
    url: '/video/page/web',
    method: 'get',
    params
  })

/**
 * 视频管理-删除视频
 * */
export const delVideoMine = id =>
  request({
    url: `video/delete/${id}`,
    method: 'delete',
  })

/**
 * 视频管理-我的视频-获取标签
 * */
export const getVideoMineLabel = () =>
  request({
    url: '/video/label',
    method: 'get',
  })

/**
 * 视频管理-我的视频-添加标签
 * */
export const addVideoMineLabel = labelName =>
  request({
    url: '/video/label',
    method: 'post',
    data: {labelName}
  })

/**
 * 视频管理-我的视频-删除标签
 * */
export const delVideoMineLabel = id =>
  request({
    url: `/video/label/${id}`,
    method: 'delete',
  })

/**
 * 视频管理-视频审核-获取待审核分页
 * */
export const getVideoAuthWaitPage = params =>
  request({
    url: '/video/page/audit/wait',
    method: 'get',
    params
  })

/**
 * 视频管理-视频审核-获取已审核分页
 * */
export const getVideoAuthResolvePage = params =>
  request({
    url: '/video/page/audit/success',
    method: 'get',
    params
  })

/**
 * 视频管理-视频审核-获取审核未通过分页
 * */
export const getVideoAuthRejectPage = params =>
  request({
    url: '/video/page/audit/failed',
    method: 'get',
    params
  })

/**
 * 视频管理-视频审核-获取视频详情
 * */
export const getVideoAuthMsg = id =>
  request({
    url: `/video/web/${id}`,
    method: 'get',
  })

/**
 * 视频管理-视频审核-审核不通过
 * */
export const setVideoAuthReject = data =>
  request({
    url: '/video/audit/failed',
    method: 'put',
    data
  })

/**
 * 视频管理-视频审核-审核通过
 * */
export const setVideoAuthResolve = videoId =>
  request({
    url: '/video/audit/success',
    method: 'put',
    data: {videoId}
  })

/**
 * 视频管理-视频审核-置顶
 * */
export const setVideoAuthTop = data =>
  request({
    url: '/video/stick',
    method: 'put',
    data
  })

/**
 * 视频管理-视频审核-取消置顶
 * */
export const setVideoAuthCancelTop = videoId =>
  request({
    url: `/video/cancel/stick/${videoId}`,
    method: 'put',
  })

/**
 * 视频管理-视频审核-下架
 * */
export const setVideoAuthSoldOut = data =>
  request({
    url: '/video/out/stock',
    method: 'put',
    data
  })

/**
 * 图库管理-获取图片列表
 * */
export const getImagePage = params =>
  request({
    url: '/picture',
    method: 'get',
    params
  })

/**
 * 图库管理-删除图片
 * */
export const delImage = pictureId =>
  request({
    url: `/picture/${pictureId}`,
    method: 'delete',
  })

/**
 * 图库管理-添加图片
 * */
export const addImage = data =>
  request({
    url: '/picture',
    method: 'post',
    data
  })
